import type { MutableRefObject } from 'react';

export const CAPTURE_FRAME_ATTRIBUTE = 'data-capture-frame';
export const CAPTURE_PAGE_ATTRIBUTE = 'data-capture-page';
export const CAPTURE_APP_ATTRIBUTE = 'data-capture-app';
export const CAPTURE_PENDING_ATTRIBUTE = 'data-capture-pending';

export interface FloatingFrameHandle {
  minimized: boolean;
  setMinimized(minimized: boolean): void;
}

const frames = new Map<string, MutableRefObject<FloatingFrameHandle>>();

export const floatingFrameId = (pluginApiName: string, apiName: string) =>
  `${pluginApiName}-${apiName}`;

export const registerFloatingFrame = (
  id: string,
  frame: MutableRefObject<FloatingFrameHandle>
) => {
  frames.set(id, frame);
  return () => {
    if (frames.get(id) === frame) frames.delete(id);
  };
};

export const floatingFrame = (id: string) => frames.get(id)?.current;
